import {useI18n} from 'i18n/I18nContext'
import {BorderStyle} from 'organization/Event/Certification/Builder/templates'
import React, {useMemo, useState} from 'react'

function borderStylesFromT(t: (k: string) => string): BorderStyle[] {
  return [
    {
      id: 1,
      label: t('orgCert.borderStyleSolid'),
      dash: undefined,
      strokeWidth: 6,
      inset: 24,
    },
    {
      id: 2,
      label: t('orgCert.borderStyleDashed'),
      dash: [12, 6],
      strokeWidth: 6,
      inset: 24,
    },
    {
      id: 3,
      label: t('orgCert.borderStyleDotted'),
      dash: [3, 6],
      strokeWidth: 4,
      inset: 24,
    },
    {
      id: 4,
      label: t('orgCert.borderStyleThin'),
      dash: undefined,
      strokeWidth: 2,
      inset: 18,
    },
  ]
}

export const BorderSelector = (props: {
  onChange: (border: BorderStyle) => void
  defaultValue?: BorderStyle
}) => {
  const {t} = useI18n()
  const styles = useMemo(() => borderStylesFromT(t), [t])
  const {onChange} = props
  const [value, setValue] = useState<number>(props.defaultValue?.id || 1)
  const handleChange = (borderId: number) => {
    setValue(borderId)
    onChange(styles.find((s) => s.id === Number(borderId))!)
  }
  return (
    <>
      <label className="input__field-text">
        {t('orgCert.labelBorderFrame')}
      </label>
      <div className="contact__select mb-15">
        <select
          value={value}
          onChange={(e) => {
            handleChange(e.target.value as unknown as number)
          }}
        >
          {styles.map((s) => (
            <option key={s.id} value={s.id}>
              {s.label}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}
